import axiosInstance from "./axiosConfig";

// API endpoint for categories
const CATEGORIES_URL = "/categories";

/**
 * Get all categories
 * @param {Object} params - Query parameters
 * @param {boolean} params.includeInactive - Whether to include inactive categories
 * @returns {Array} List of categories
 */
const getCategories = async (params = {}) => {
  console.log("categoryService.getCategories called with params:", params);
  const response = await axiosInstance.get(CATEGORIES_URL, { params });
  console.log("categoryService.getCategories response:", response.data);
  return response.data;
};

/**
 * Get category by ID
 * @param {string} id - Category ID
 * @returns {Object} Category data
 */
const getCategoryById = async (id) => {
  const response = await axiosInstance.get(`${CATEGORIES_URL}/${id}`);
  return response.data;
};

/**
 * Create a new category
 * @param {Object} categoryData - Category data to create
 * @returns {Object} Created category data
 */
const createCategory = async (categoryData) => {
  const response = await axiosInstance.post(CATEGORIES_URL, categoryData);
  return response.data;
};

/**
 * Update category
 * @param {string} id - Category ID
 * @param {Object} categoryData - Category data to update
 * @returns {Object} Updated category data
 */
const updateCategory = async (id, categoryData) => {
  const response = await axiosInstance.put(
    `${CATEGORIES_URL}/${id}`,
    categoryData
  );
  return response.data;
};

/**
 * Delete category
 * @param {string} id - Category ID
 * @returns {Object} Success message
 */
const deleteCategory = async (id) => {
  const response = await axiosInstance.delete(`${CATEGORIES_URL}/${id}`);
  return response.data;
};

const categoryService = {
  getCategories,
  getCategoryById,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService;
